import { Button, TextField } from "@mui/material";
import { type FC, useCallback, useState } from "react";
import type { Selection } from "../use-co-pilot-types";

export const RefineInput: FC<{
  prompt?: string;
  suggestion?: string;
  onRefine: (prompt: string) => void;
  selection?: Selection;
  loading?: boolean;
}> = ({ loading, onRefine }) => {
  const [newPrompt, setNewPrompt] = useState("");

  const handleRefine = useCallback(() => {
    onRefine(newPrompt);
    setNewPrompt("");
  }, [newPrompt, onRefine]);

  return (
    <TextField
      fullWidth
      multiline
      maxRows={3}
      value={newPrompt}
      onChange={(e) => setNewPrompt(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
          handleRefine();
        }
      }}
      placeholder="Ask Co-Pilot to..."
      disabled={loading}
      label="Ask Co-Pilot to..."
      slotProps={{
        input: {
          endAdornment: (
            <Button
              data-analytics-id="lexical-co-pilot-refine"
              onClick={handleRefine}
              variant="outlined"
              disabled={loading || newPrompt.length === 0}
              size="small"
            >
              Refine
            </Button>
          ),
        },
      }}
    />
  );
};
